const config = {
  connectGWEndpoint: 'https://dev-api.connect.skoda-auto.cz/' ,
  login: 'https://feedback-admin.dev-api.connect.skoda-auto.cz/saml2/authenticate/feedback-admin',
};

export default config;
